import { render, staticRenderFns } from "./BlacklistBase.vue?vue&type=template&id=15ac2472&scoped=true&"
import script from "./BlacklistBase.vue?vue&type=script&lang=js&"
export * from "./BlacklistBase.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistBase.vue?vue&type=style&index=0&id=15ac2472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac2472",
  null
  
)

export default component.exports